export enum SocketActionEnum {
  // monitor
  UPDATE_MONITOR = 'update-monitor',
  UPDATE_MONITOR_AGENT = 'update-monitor-agent',
  UPDATE_MONITOR_ALL_AGENT = 'update-monitor-all-agent',
  UPDATE_MONITOR_AGENT_PHONE_TYPE = 'update-monitor-agent-phone-type',
  UPDATE_MONITOR_CALL = 'update-monitor-call',
  UPDATE_MONITOR_AGENT_DASHBOARD = 'update-monitor-agent-dashboard',
  UPDATE_MONITOR_CALL_LIST = 'update-monitor-calllist',
  UPDATE_MONITOR_CALL_DETAIL = 'update-monitor-calldetail',
  UPDATE_MONITOR_CALL_DETAIL_END = 'update-monitor-calldetail-end',
  // agent
}



// WEBPACK FOOTER //
// ./src/app/common/enums/socket-action.enum.ts